<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Sales</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        icon
        @click="items=[]; getSalesOrders(txtOrderNo, txtInvoiceNo, txtName, txtEmail, cboSellerUserId, txtProductId, cboStatus, txtMinOrderDate, txtMaxOrderDate, cboCourierId, cboPaymentMethodId, cboSort); rightDrawer=false;"
      >
        <v-icon>autorenew</v-icon>
      </v-btn>
      <v-btn icon @click.stop="rightDrawer = !rightDrawer" class="white--text">
        <v-icon>filter_list</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer
      temporary
      right
      v-model="rightDrawer"
      fixed
      app
      :width=500
    >
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex
            xs12
            text-xs-center
            layout
            align-center
            justify-center
            class="pl-4 pr-4"
          >
            <v-form ref="form" v-model="frmValid" lazy-validation @submit.prevent="">
              <v-text-field
                v-model="txtName"
                label="Name"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-text-field
                v-model="txtEmail"
                label="Email"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-select
                v-model="cboSellerUserId"
                :items="sellers"
                item-text="storeName"
                item-value="storeId"
                label="Seller"
              ></v-select>
              <v-text-field
                v-model="txtOrderNo"
                label="Order No"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-text-field
                v-model="txtInvoiceNo"
                label="Invoice No"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-text-field
                v-model="txtProductId"
                label="Product Id"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-select
                v-model="cboStatus"
                :items="statuses"
                label="Status"
              ></v-select>
              <v-menu
                ref="dtMinOrderDate"
                :close-on-content-click="false"
                v-model="dtMinOrderDate"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="txtMinOrderDate"
                  label="Min Order Date"
                ></v-text-field>
                <v-date-picker v-model="txtMinOrderDate" no-title @input="dtMinOrderDate = false"></v-date-picker>
              </v-menu>
              <v-menu
                ref="dtMaxOrderDate"
                :close-on-content-click="false"
                v-model="dtMaxOrderDate"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="txtMaxOrderDate"
                  label="Max Order Date"
                ></v-text-field>
                <v-date-picker v-model="txtMaxOrderDate" no-title @input="dtMaxOrderDate = false"></v-date-picker>
              </v-menu>
              <v-select
                v-model="cboCourierId"
                :items="couriers"
                item-text="courierName"
                item-value="courierId"
                label="Courier"
              ></v-select>
              <v-select
                v-model="cboPaymentMethodId"
                :items="paymentMethods"
                item-text="paymentMethodName"
                item-value="paymentMethodId"
                label="Payment Method"
              ></v-select>
              <v-text-field
                v-model="txtVoucher"
                label="Voucher"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-select
                v-model="cboSort"
                :items="sorts"
                item-text="title"
                item-value="key"
                label="Sorting"
              ></v-select>
              <v-btn
                @click="clickFilter()"
              >
                Filter
              </v-btn>
              <v-btn @click="clearFilter(); getSalesOrders(txtOrderNo, txtInvoiceNo, txtName, txtEmail, cboSellerUserId, txtProductId, cboStatus, txtMinOrderDate, txtMaxOrderDate, cboCourierId, cboPaymentMethodId, cboSort); rightDrawer=false;">Reset</v-btn>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
    <v-content>
      <v-tabs
        color="grey darken-4"
      >
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          v-for="(item, index) in tabs"
          :key="index"
          :to="'/orders/' + item.key"
        >
          <v-badge v-if="item.key === 'reviewed' && profile.pendingReviewForReplyCount > 0" color="red">
            <template v-slot:badge>
              <span class="caption">{{ profile.pendingReviewForReplyCount }}</span>
            </template>
            {{ item.title }}
          </v-badge>
          <span v-else>{{ item.title }}</span>
        </v-tab>
      </v-tabs>
      <v-container v-if="items.length > 0" fluid grid-list-xs class="pa-0">
        <v-layout row wrap v-for="(item, index) in items" :key="item.salesOrderNo" :class="(index % 2 === 0 ? 'row1' : 'row2')">
          <v-flex xs2 sm1 class="text-xs-center pa-2 pt-4 pb-3">
            <v-icon v-if="item.deliveryStatus === 'sent'" medium color="green darken-2">check_circle_outline</v-icon>
            <v-icon v-else-if="item.paymentStatus === 'partial'" medium color="orange lighten-2">opacity</v-icon>
            <v-icon v-else-if="item.paymentStatus === 'paid' || item.paymentStatus === 'credit'" medium color="orange lighten-2">play_circle_outline</v-icon>
            <v-icon v-else-if="item.paymentStatus === 'pending'" medium color="white darken-1">hourglass_empty</v-icon>
            <v-icon v-else-if="item.paymentStatus === 'in-verification'" medium color="grey">policy</v-icon>
            <v-icon v-else-if="item.paymentStatus === 'rejected' || item.paymentStatus === 'expired'" medium color="red darken-1">clear</v-icon>
            <v-icon v-else medium color="grey darken-1">hourglass_empty</v-icon>
            <div class="caption grey--text">{{ item.paymentStatus | allCaps }}</div>
          </v-flex>
          <v-flex xs6 sm7 class="text-xs-left pa-2 pt-3 pb-3">
            <div class="caption grey--text">
              {{ item.displayDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
            </div>
            <div>
              <router-link class="font-weight-bold orange--text text--lighten-2" :to="'/order/' + item.salesOrderNo">{{ item.salesOrderNo }}</router-link>
              <span v-if="item.invoiceNo" class="caption ml-3">({{ item.invoiceNo }})</span>
              <span v-if="item.paymentStatus === 'chargeback'" class="body-1 ml-3 font-weight-bold red--text">CHARGEBACK</span>
              <span class="ml-2">-</span>
              <span class="body-1 ml-2">(
                <span v-for="(seller, sellerIndex) in item.sellers" :key="seller.sellerUserId" class="ml-0 mr-0">
                  {{ seller.storeName }}
                  <span v-if="sellerIndex < (item.sellers.length - 1)" class="mr-2">,</span>
                </span>
                )
              </span>
            </div>
            <div class="text--primary">
              {{ item.shippingEmail }} - {{ item.paymentMethodName }}
              <span v-if="item.deliveryStatus !== 'pending'" :class="(item.deliveryStatus === 'pending' ? 'orange--text text--lighten-2' : (item.deliveryStatus === 'partial' ? 'orange--text' : (item.deliveryStatus === 'sent' ? 'green--text' : ''))) + ' font-weight-bold ml-2'">[{{ item.deliveryStatus | allCaps }}]</span>
            </div>
            <div>
              {{ item.shippingCityName }}, {{ item.shippingProvinceName }}, {{ item.shippingCountryName }}
            </div>
          </v-flex>
          <v-flex xs4 sm3 class="text-xs-right pa-3">
            <div class="title">
              <span v-if="item.cacheTotalVoucherDiscount > 0" class="caption grey--text mr-2">Voucher: -{{ item.currencySign + formatPrice(item.cacheTotalVoucherDiscount, item.currencyDecimals, item.currencyDecimalSign) }}</span>
              <strong>{{ item.currencySign + formatPrice(item.cacheTotalSales + item.deliveryCost + item.importTariff, item.currencyDecimals, item.currencyDecimalSign) }}</strong>
            </div>
            <div v-if="item.reviewRating > 0" class="mt-2">
              <v-rating
                empty-icon="star"
                background-color="grey darken-2"
                color="orange"
                :size=14
                half-increments
                :value="item.reviewRating"
                readonly
                dense
              ></v-rating>
              <div class="caption grey--text">
                {{ item.reviewDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
              </div>
              <div class="caption font-italic">
                {{ item.review }}
              </div>
              <div v-if="item.reviewReply !== ''" class="pa-3 mt-3" style="border: 1px solid #ff9900;">
                <div class="caption grey--text">Replied by {{ item.reviewRepliedByAdminName }} on {{ item.reviewRepliedDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</div>
                <div class="font-italic">" {{ item.reviewReply }} "</div>
              </div>
              <div v-else-if="item.reviewRating <= 3 && item.reviewReply === ''" class="orange--text blink-text">
                <v-icon color="orange" small>error_outline</v-icon> Need reply
              </div>
            </div>
            <div v-else-if="item.reviewRequestedDateTime !== ''" class="mt-2">
              <div class="caption grey--text">Review requested by {{ item.reviewRequestedByAdminName }} on {{ item.reviewRequestedDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</div>
            </div>
          </v-flex>
          <v-flex sm1 class="text-xs-center pt-4 pr-3 pl-0 hidden-xs-only">
            <v-btn icon color="primary" :to="'/order/' + item.salesOrderNo">
              <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container v-else fluid grid-list-xs class="pa-0">
        <v-layout row wrap class="row1">
          <v-flex xs12 class="text-xs-center pa-2 pt-4 pb-4">
            <v-icon x-large color="primary">error_outline</v-icon>
            <div>
              No sales yet
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container fluid grid-list-xs class="mt-3 mb-0">
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-center">
            <div class="mb-3">
              Showing {{ listCountFrom }} - {{ listCountTo }} of {{ listTotal }} orders
            </div>
          </v-flex>
          <v-flex xs12 class="text-xs-center hidden-sm-and-up">
            <v-pagination
              v-model="pageNo"
              :length="(pageCount ? pageCount : 0)"
              :total-visible="5"
              circle
            ></v-pagination>
          </v-flex>
          <v-flex xs12 class="text-xs-center hidden-xs-only">
            <v-pagination
              v-model="pageNo"
              :length="(pageCount ? pageCount : 0)"
              :total-visible="12"
              circle
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-container>

      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>

    </v-content>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.tabs__slider {
  height: 3px;
}

form {
  width: 100%;
}

</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import moment from 'moment'
import axios from 'axios'
import router from '../router'
import { EventBus } from '../main'

export default {
  props: [
    'status'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      def: this.$store.getters.getDef,
      drawer: false,
      rightDrawer: false,
      loading: false,
      autoloadInterval: null,
      frmValid: true,
      txtName: '',
      txtEmail: '',
      txtOrderNo: '',
      txtInvoiceNo: '',
      txtProductId: '',
      dtMinOrderDate: false,
      dtMaxOrderDate: false,
      txtMinOrderDate: '',
      txtMaxOrderDate: '',
      cboSellerUserId: '',
      sellers: [],
      cboCourierId: '',
      couriers: [],
      cboPaymentMethodId: '',
      paymentMethods: [],
      txtVoucher: '',
      cboStatus: '',
      statuses: ['all', 'pending', 'in-progress', 'shipped', 'unpaid', 'reviewed'],
      cboType: '',
      types: ['retail', 'wholesale'],
      cboSort: '',
      sorts: [
        {
          key: 'createdDateTime:desc',
          title: 'Latest'
        },
        {
          key: 'createdDateTime:asc',
          title: 'From beginning'
        },
        {
          key: 'reviewDateTime:desc',
          title: 'Latest review'
        }
      ],
      isLoadingItems: false,
      items: [],
      listLimit: 15,
      listOffset: 0,
      listTotal: 0,
      listCountFrom: 0,
      listCountTo: this.listLimit,
      pageNo: parseInt(this.$route.query.pg) || 1,
      pageCount: 0,
      tabs: [
        {
          key: 'pending',
          title: 'Pending'
        },
        {
          key: 'in-progress',
          title: 'In-progress'
        },
        {
          key: 'shipped',
          title: 'Shipped'
        },
        {
          key: 'unpaid',
          title: 'Unpaid'
        },
        {
          key: 'canceled',
          title: 'Canceled'
        },
        {
          key: 'reviewed',
          title: 'Reviewed'
        },
        {
          key: 'all',
          title: 'All'
        }
      ]
    }
  },
  computed: {
    profile () {
      return this.$store.getters.getProfile
    }
  },
  created () {
    var _this = this
    EventBus.$on('logout', function () {
      clearInterval(_this.autoloadInterval)
    })
    // window.addEventListener('scroll', this.detectBottomOfWindow)
  },
  destroyed () {
    // window.removeEventListener('scroll', this.detectBottomOfWindow)
  },
  mounted () {
    this.openDrawerForDesktop()

    // init
    this.clearFilter()
    this.txtOrderNo = this.$route.query.order_no || ''
    this.txtInvoiceNo = this.$route.query.invoice_no || ''
    this.txtProductId = this.$route.query.product_id || ''
    this.txtEmail = this.$route.query.email || ''
    this.txtName = this.$route.query.name || ''
    this.cboSellerUserId = this.$route.query.seller_user_id || ''
    this.txtMinOrderDate = this.$route.query.min_date || ''
    this.txtMaxOrderDate = this.$route.query.max_date || ''
    this.cboCourierId = this.$route.query.courier || ''
    this.cboPaymentMethodId = this.$route.query.method || ''
    this.txtVoucher = this.$route.query.voucher || ''
    this.cboSort = this.$route.query.sort || (this.status === 'reviewed' ? 'reviewDateTime:desc' : '') || ''

    this.getSalesOrders(this.txtOrderNo, this.txtInvoiceNo, this.txtName, this.txtEmail, this.cboSellerUserId, this.txtProductId, this.cboStatus, this.txtMinOrderDate, this.txtMaxOrderDate, this.cboCourierId, this.cboPaymentMethodId, this.txtVoucher, this.cboSort)
    this.listCouriers()
    this.listSellers()
    this.listPaymentMethods()

    var _this = this
    _this.autoloadInterval = setInterval(function () {
      _this.items = []
      _this.getSalesOrders(_this.txtOrderNo, _this.txtInvoiceNo, _this.txtName, _this.txtEmail, _this.cboSellerUserId, _this.txtProductId, _this.cboStatus, _this.txtMinOrderDate, _this.txtMaxOrderDate, _this.cboCourierId, _this.cboPaymentMethodId, _this.txtVoucher, _this.cboSort)
    }, (5 * 60 * 1000))
  },
  watch: {
    pageNo (val, oldVal) {
      // If page no changes, navigate to new page
      this.getSalesOrders(this.txtOrderNo, this.txtInvoiceNo, this.txtName, this.txtEmail, this.cboSellerUserId, this.txtProductId, this.cboStatus, this.txtMinOrderDate, this.txtMaxOrderDate, this.cboCourierId, this.cboPaymentMethodId, this.txtVoucher, this.cboSort, (val - 1) * this.listLimit)
    }
  },
  methods: {
    detectBottomOfWindow: function () {
      // console.log(document.documentElement.scrollTop + window.innerHeight) - 48
      // console.log(document.documentElement.offsetHeight)
      let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight >= (document.documentElement.offsetHeight - 5)

      if (bottomOfWindow) {
        if (this.listTotal > this.items.length) {
          this.getSalesOrders(this.txtOrderNo, this.txtInvoiceNo, this.txtName, this.txtEmail, this.cboSellerUserId, this.txtProductId, this.cboStatus, this.txtMinOrderDate, this.txtMaxOrderDate, this.cboCourierId, this.cboPaymentMethodId, this.txtVoucher, this.cboSort, this.items.length)
        }
      }
    },
    listSellers: function () {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/users?type=seller,virtual,branch,franchise&limit=30')
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.sellers = resp.data.data
            } else {
              console.log('unable to load sellers: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              _this.loading = false
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                reject(error.response.status)
              }
            }
          })
      })
      return promise
    },
    listCouriers: function () {
      var url = process.env.VUE_APP_API_ROOT + '/v1/shipping/couriers/CHN'
      var _this = this
      axios.get(url)
        .then(resp => {
          if (resp.data.status === 'success') {
            _this.couriers = resp.data.data
          } else {
            console.log('unable to list couriers: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              clearInterval(_this.autoloadInterval)
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              clearInterval(_this.autoloadInterval)
              console.log(error.response)
            }
            _this.loading = false
          }
        })
    },
    listPaymentMethods: function () {
      var url = process.env.VUE_APP_API_ROOT + '/v1/payment/methods'
      var _this = this
      axios.get(url)
        .then(resp => {
          if (resp.data.status === 'success') {
            _this.paymentMethods = resp.data.data
          } else {
            console.log('unable to list payment methods: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              clearInterval(_this.autoloadInterval)
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              clearInterval(_this.autoloadInterval)
              console.log(error.response)
            }
            _this.loading = false
          }
        })
    },
    clickFilter: function () {
      this.items = []
      this.rightDrawer = false
      if (this.cboStatus === this.status) {
        this.getSalesOrders(this.txtOrderNo, this.txtInvoiceNo, this.txtName, this.txtEmail, this.cboSellerUserId, this.txtProductId, this.cboStatus, this.txtMinOrderDate, this.txtMaxOrderDate, this.cboCourierId, this.cboPaymentMethodId, this.txtVoucher, this.cboSort)
      } else {
        router.push('/orders/' + this.cboStatus + '?order_no=' + this.txtOrderNo + '&invoice_no=' + this.txtInvoiceNo + '&product_id=' + this.txtProductId + '&name=' + this.txtName + '&email=' + this.txtEmail + '&seller_user_id=' + this.cboSellerUserId + '&min_date=' + this.txtMinOrderDate + '&max_date=' + this.txtMaxOrderDate + '&courier=' + this.cboCourierId + '&method=' + this.cboPaymentMethodId + '&voucher=' + this.txtVoucher + '&sort=' + this.cboSort)
      }
    },
    getSalesOrders: function (orderNo = '', invoiceNo = '', name = '', email = '', sellerUserId = '', productId = '', status = '', minCreatedDate = '', maxCreatedDate = '', courierId = '', paymentMethodId = '', voucher = '', sort = '', offset = 0) {
      var _this = this
      var params = ''
      switch (status) {
        case 'pending':
          params = 'payment_status=pending,partial,in-verification'
          break
        case 'in-progress':
          params = 'payment_status=paid,credit,chargeback&delivery_status=pending,partial'
          break
        case 'shipped':
          params = 'delivery_status=sent,delivered'
          break
        case 'unpaid':
          params = 'payment_status=none'
          break
        case 'canceled':
          params = 'payment_status=rejected,expired'
          break
        case 'reviewed':
          params = 'min_rating=1'
          break
      }

      if (courierId === null) {
        courierId = ''
      }

      if (minCreatedDate !== '') {
        minCreatedDate = moment.utc(minCreatedDate + ' 00:00:00' + _this.profile.gmtTimezone).format('YYYY-MM-DD HH:mm:ss')
      }
      if (maxCreatedDate !== '') {
        maxCreatedDate = moment.utc(maxCreatedDate + ' 00:00:00' + _this.profile.gmtTimezone).format('YYYY-MM-DD HH:mm:ss')
      }

      if (_this.isLoadingItems === false) {
        _this.isLoadingItems = true
        params += '&order_no=' + orderNo + '&invoice_no=' + invoiceNo + '&name=' + name + '&email=' + email + '&seller_user_id=' + sellerUserId + '&product_id=' + productId + '&courier_id=' + courierId + '&min_created_datetime=' + minCreatedDate + '&max_created_datetime=' + maxCreatedDate + '&payment_method_id=' + paymentMethodId + '&voucher=' + voucher + '&sort=' + sort + '&limit=' + _this.listLimit + '&offset=' + offset
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/sales?' + params)
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              for (var i in resp.data.data) {
                // inject displayDateTime
                if (resp.data.data[i].paymentStatus === 'paid' || resp.data.data[i].paymentStatus === 'credit') {
                  resp.data.data[i].displayDateTime = resp.data.data[i].paidDateTime
                } else {
                  resp.data.data[i].displayDateTime = resp.data.data[i].createdDateTime
                }

                // inject payment method names
                if (resp.data.data[i].paymentStatus !== 'none') {
                  let methodNamesObject = {}
                  let methodNames = ''
                  for (var j in resp.data.data[i].payments) {
                    // filter distinct methods only
                    if (typeof methodNamesObject[resp.data.data[i].payments[j].paymentMethodName] === 'undefined') {
                      methodNamesObject[resp.data.data[i].payments[j].paymentMethodName] = resp.data.data[i].payments[j].paymentMethodName
                      if (methodNames !== '') {
                        methodNames = methodNames + ', '
                      }
                      methodNames = methodNames + resp.data.data[i].payments[j].paymentMethodName
                    }
                  }
                  resp.data.data[i].paymentMethodName = methodNames
                }
              }
              _this.items = resp.data.data
              _this.listLimit = resp.data.limit
              _this.listOffset = resp.data.offset
              _this.listTotal = resp.data.total
              _this.pageCount = Math.ceil(_this.listTotal / _this.listLimit)
              _this.listCountFrom = _this.listOffset + 1
              _this.listCountTo = (_this.listCountFrom - 1) + _this.items.length
              if (_this.items.length === 0) {
                _this.listCountFrom = 0
                _this.listCountTo = 0
              }

              if (status === 'reviewed' && _this.profile.isNewReviewSubmitted === '1') {
                setTimeout(function () {
                  _this.$store.dispatch('UPDATE_PROFILE')
                }, (2 * 1000))
              }
            } else {
              console.log('unable to load sales order list: ' + resp.data.message)
            }
            _this.isLoadingItems = false
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                clearInterval(_this.autoloadInterval)
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                clearInterval(_this.autoloadInterval)
                _this.showAlert(error)
              }
              _this.loading = false
              _this.isLoadingItems = false
            }
          })
      }
    },
    clearFilter () {
      this.cboStatus = this.status
      if (typeof this.cboStatus === 'undefined' || this.cboStatus === '') {
        this.cboStatus = 'pending'
      }
      this.txtOrderNo = ''
      this.txtInvoiceNo = ''
      this.txtEmail = ''
      this.txtName = ''
      this.cboSellerUserId = ''
      this.txtProductId = ''
      this.txtMinOrderDate = ''
      this.txtMaxOrderDate = ''
      this.cboCourierId = ''
      this.cboPaymentMethodId = ''
      this.txtVoucher = ''
      this.cboSort = ''
      this.items = []
      this.listOffset = 0
      this.listTotal = 0
      this.pageCount = 1
      this.listCountFrom = 0
      this.listCountTo = 0
      this.pageNo = 1
      this.rightDrawer = false
    }
  }
}

</script>
